import React from 'react';
import { SemipolarSpinner } from 'react-epic-spinners';

export const Loader = (props) => {
    return (
        <>
            {props.active ?
                <div className="loader-smsng">
                    <div className="loaderWrapper">
                        <div className='bx-ldr'>
                            <SemipolarSpinner
                                size={50}
                                color="#000"
                            />
                        </div>
                    </div>
                </div>
                :
                null
            }
        </>
    );
}